'use client';

import { ThemeProvider } from 'next-themes';

interface ThemeClientProps {
    children: React.ReactNode;
}

export default function ThemeClient({ children }: ThemeClientProps) {
    return (
        <ThemeProvider
            attribute="class"
            defaultTheme="dark"
            enableSystem
            disableTransitionOnChange
        >
            {children}
        </ThemeProvider>
    );
}
